const mobilePageCrops = [
  { page: '1', x: '48%', y: '50%' },
	{ page: '3', x: '35%', y: '50%' },
  { page: '4', x: '35%', y: '50%' },
  { page: '15', x: '51%', y: '0%' },
  { page: '17', x: '35%', y: '50%' },
  { page: '18', x: '100%', y: '50%' },
  { page: '20', x: '25%', y: '50%' },
  { page: '21', x: '45%', y: '50%' },
  { page: '23', x: '0%', y: '50%' },
  { page: '25', x: '35%', y: '50%' },
  { page: '29', x: '5%', y: '0%', scale: 0.5, autoHeight: true },
  { page: '30', x: '25%', y: '60%' },
  { page: '31', x: '0%', y: '50%', scale: 0.5, autoHeight: true }
];

export default mobilePageCrops;